import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Box,
  Typography,
  Modal,
  Menu,
  MenuItem,
  TextField,
  Button,TablePagination,
  IconButton,CircularProgress,FormControl,InputLabel,Select

} from "@mui/material";
import { MoreVert, Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useFetch, useDelete, useUpdate } from "../../hooks";
import { urls } from "../../urls/urls";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { SnackBarComponent } from "../../components";

const vendorsData = [
  { sno: 1, name: "Vendor 1", shop: "Marketing Agency 1" },
  { sno: 2, name: "Vendor 2", shop: "Marketing Agency 2" },
  { sno: 3, name: "Vendor 3", shop: "Marketing Agency 3" },
];


export default function AdminBusinessNature({data,refreshData}) {
  console.log("bnaturedata",data)
  const loginToken=useSelector((state)=>state.user.logintoken)
  console.log("logintoken",loginToken)
   const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success", // Default severity
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });

  const {
    data: NatureData,
    isLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("creaateBNature"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deleteData1,
    isLoading: deleteDataLoading,
    error: deleteDataError,
    deleteData: deleteFetchData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateData1,
    isLoading: updateDataLoading,
    error: updateDataError,
    updateData,
  } = useUpdate(BASE_URL_TEST, {
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // console.log("bnature data",data)

  useEffect(() => {
    if (error) {
    } else if (NatureData && NatureData["status"] === true) {
      console.log("NatureData", NatureData);
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: NatureData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      refreshData();
    }
  }, [NatureData, error]);

  useEffect(() => {
    if (deleteDataError) {
    } else if (deleteData1 && deleteData1["status"] === true) {
      console.log("NatureData", NatureData);
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: deleteData1["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      // setModalOpen(false);
      refreshData();
    }
  }, [deleteData1, deleteDataError]);

  useEffect(() => {
    if (updateDataError) {
    } else if (updateData1 && updateData1["status"] === true) {
      console.log("updateData1", updateData1);
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: updateData1["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      refreshData();
    }
  }, [updateData1, updateDataError]);

  const [vendors, setVendors] = useState(data);
  const [vendorId, setVendorId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [newVendor, setNewVendor] = useState({
    sno: "",
    name: "",
    description: "",
    status: 0,
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [search, setSearch] = useState("");
  const [natureNameError, setNatureNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");

  const handlePageChange = (event, newPage) => {
    console.log("object,",newPage)
    setPage(newPage);
    
  };

  const handleRowsPerPageChange = (event) => {
    console.log("objectrows",event)
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  const handleMenuClick = (event, vendor) => {
    setAnchorEl(event.currentTarget);
    setSelectedVendor(vendor);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedVendor(null);
  };

  const handleDelete = (item) => {
    console.log("delte item", item);

    deleteFetchData(item["business_id"]);
    const deleteUrl = urls("deleteBNature", item["business_id"]);
    deleteFetchData(deleteUrl);
  };

  const handleOpenAddModal = () => {
    setIsEditMode(false);
    setNewVendor({ sno: "", name: "", description: "" });
    setModalOpen(true);
  };

  const handleOpenEditModal = () => {
    setIsEditMode(true);
    console.log("bNatue edit", selectedVendor);
    setNewVendor(selectedVendor);
    setModalOpen(true);
    handleMenuClose();
  };

  const handleAddOrUpdateVendor = () => {
    if (isEditMode) {
      console.log("selectevendor", newVendor);
      setVendors(vendors.map((v) => (v.sno === newVendor.sno ? newVendor : v)));
      const updateUrl = urls("updateBNature", newVendor["business_id"]);
      updateData(updateUrl, {
        name: newVendor["name"],
        description: newVendor["description"],
        status: newVendor["status"]
      });
    } else {
      if (!newVendor["name"].trim()) {
        setNatureNameError("Nature name is required");
        return;
      } else if (!newVendor["description"].trim()) {
        setDescriptionError("Description is required");
        return;
      } else {
        fetchData({
          name: newVendor["name"],
          description: newVendor["description"],
        });
      }

      // setVendors([...vendors, { ...newVendor, sno: vendors.length + 1 }]);
    }
    // setModalOpen(false);
    // setNewVendor({ sno: "", name: "", shop: "" });
  };

  const handleClose = () => {
    setModalOpen(false);
    setNewVendor({ sno: "", name: "", description: "" });
  };
  // Handle search
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const filteredData = search
    ? data.filter(
        (item) =>
          item.name.toLowerCase().includes(search.toLowerCase()) ||
          item.description.toLowerCase().includes(search.toLowerCase())
      )
    : data;

  return (
    <Box sx={{ padding: 3, backgroundColor: "#F9FAFC" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          borderRadius: "20px",
        }}
      >
        <SnackBarComponent
          open={snackbarState.open}
          onClose={handleSnackbarClose}
          severity={snackbarState.severity}
          message={snackbarState.message}
          position={snackbarState.position}
        />

        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{
            width: "30%",
            backgroundColor: "#FFF",
            borderRadius: 1,
          }}
        />

        {/* Add Button */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 2,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenAddModal}
            sx={{
              backgroundColor: "#28A745",
              "&:hover": { backgroundColor: "#218838" },
              textTransform: "none",
              fontWeight: "bold",
            }}
          >
            Add
          </Button>
        </Box>
      </Box>

      <Box>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <CircularProgress />
          </Box>
        ) : null}
      </Box>

      {/* Vendor Table */}
      <TableContainer component={Paper} sx={{ borderRadius: "20px", p: 0 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Bn.no</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length > 0 ? (
              filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((vendor) => (
                <TableRow key={vendor.business_id}>
                  <TableCell>{vendor.business_id}</TableCell>
                  <TableCell style={{ display: "flex", alignItems: "center" }}>
                    <Avatar
                      style={{ marginRight: 10 }}
                      alt={vendor.name}
                      src="/path-to-avatar.jpg"
                    />
                    {vendor.name}
                  </TableCell>
                  <TableCell>{vendor.description}</TableCell>

                  {/* Action Column with 3 Dots Menu */}
                  <TableCell>
                    <IconButton onClick={(e) => handleMenuClick(e, vendor)}>
                      <MoreVert />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={
                        Boolean(anchorEl) && selectedVendor?.sno === vendor.sno
                      }
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={handleOpenEditModal}>Edit</MenuItem>
                      <MenuItem onClick={() => handleDelete(vendor)} sx={{display:'none'}}>
                        Delete
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} style={{ textAlign: "center" }}>
                  No data found for the searched product.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

        <TablePagination
                rowsPerPageOptions={[5, 10, 25,50,100]}
                component="div"
                count={data&&data.length?data.length:0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
              />

      {/* Add/Edit Vendor Modal */}
      <Modal open={isModalOpen} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100vw - 24px)", sm: 400 },
            maxWidth: "100%",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            position: "relative",
          }}
        >
          <IconButton
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
            onClick={handleClose}
          >
            <Close />
          </IconButton>

          <Typography variant="h6" mb={2}>
            {isEditMode ? "Edit Business" : "Add Business"}
          </Typography>
          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            value={newVendor.name}
            error={!!natureNameError}
            helperText={
              natureNameError && (
                <Typography
                  sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                >
                  {natureNameError}
                </Typography>
              )
            }
            onChange={
              (e) => setNewVendor({ ...newVendor, name: e.target.value })
              // setName(e.target.value)
            }
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Description"
            variant="outlined"
            value={newVendor.description}
            error={!!descriptionError}
            helperText={
              descriptionError && (
                <Typography
                  sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                >
                  {descriptionError}
                </Typography>
              )
            }
            onChange={(e) =>
              setNewVendor({ ...newVendor, description: e.target.value })
            }
            sx={{ mb: 2 }}
          />
          {isEditMode ? (
            <FormControl fullWidth sx={{ mb: 5 }}>
              <InputLabel>Status</InputLabel>
              <Select
                value={newVendor.status || 0} // Default to 0 (Deactive) if status is not set
                onChange={(e) =>
                  setNewVendor((prev) => ({ ...prev, status: e.target.value }))
                }
                label="Status"
              >
                <MenuItem value={1}>Active</MenuItem>
                <MenuItem value={0}>Deactive</MenuItem>
              </Select>
            </FormControl>
          ) : null}
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => handleAddOrUpdateVendor()}
          >
            {isEditMode ? "Update" : "Add"}
          </Button>
        </Box>
      </Modal>
    </Box>
  );
}
